// // src/pages/RegisterPage.js
// import React from 'react';
// import { Container, Form, Button, Card, Row, Col } from 'react-bootstrap';
// import { FaUserPlus } from 'react-icons/fa';
// import { Link } from 'react-router-dom';

// const RegisterPage = () => {
//   return (
//     <Container className="py-5">
//       <Row className="justify-content-center">
//         <Col md={6}>
//           <Card>
//             <Card.Body>
//               <h2 className="text-center mb-4">
//                 <FaUserPlus className="me-2" />
//                 Register
//               </h2>
//               <Form>
//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="firstName">
//                       <Form.Label>First Name</Form.Label>
//                       <Form.Control type="text" placeholder="Enter first name" />
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="lastName">
//                       <Form.Label>Last Name</Form.Label>
//                       <Form.Control type="text" placeholder="Enter last name" />
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Form.Group className="mb-3" controlId="email">
//                   <Form.Label>Email address</Form.Label>
//                   <Form.Control type="email" placeholder="Enter email" />
//                 </Form.Group>

//                 <Form.Group className="mb-3" controlId="password">
//                   <Form.Label>Password</Form.Label>
//                   <Form.Control type="password" placeholder="Password" />
//                 </Form.Group>

//                 <Form.Group className="mb-3" controlId="confirmPassword">
//                   <Form.Label>Confirm Password</Form.Label>
//                   <Form.Control type="password" placeholder="Confirm password" />
//                 </Form.Group>

//                 <div className="d-grid">
//                   <Button variant="primary" type="submit">
//                     Register
//                   </Button>
//                 </div>
//               </Form>

//               <div className="text-center mt-3">
//                 <Link to="/login">Already have an account? Login</Link>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default RegisterPage;

import React from 'react';
import { Container, Form, Button, Card, Row, Col } from 'react-bootstrap';
import { FaUserPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const RegisterPage = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card>
            <Card.Body>
              <h2 className="text-center mb-4">
                <FaUserPlus className="me-2" />
                Register
              </h2>
              <Form>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="firstName">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control type="text" placeholder="Enter first name" />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="lastName">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control type="text" placeholder="Enter last name" />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control type="email" placeholder="Enter email" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" placeholder="Password" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="confirmPassword">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control type="password" placeholder="Confirm password" />
                </Form.Group>

                <div className="d-grid">
                  <Button variant="primary" type="submit">
                    Register
                  </Button>
                </div>
              </Form>

              <div className="text-center mt-3">
                <Link to="/login">Already have an account? Login</Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default RegisterPage;
